export default __webpack_public_path__ + "static/1629-4b8da67824169823d88e1862d69aa9c6.gif";